"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractStudentView = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const Factory_1 = require("../Factory");
const Markdown_1 = require("../util/Markdown");
const SortableTable_1 = require("../util/SortableTable");
const UI_1 = require("../util/UI");
const ViewAs_1 = require("../util/ViewAs");
class AbstractStudentView {
    constructor() {
        this.remote = null;
        this.person = null;
        this.grades = [];
        this.repos = [];
    }
    pushPage(pageName, opts) {
        Log_1.default.info("AbstractStudentView::pushPage( " + pageName + ", ... ) - start");
        if (typeof opts !== "object") {
            opts = {};
        }
        const prefix = Factory_1.Factory.getInstance().getHTMLPrefix();
        UI_1.UI.pushPage(prefix + "/" + pageName, opts)
            .then(function () {
        })
            .catch(function (err) {
            Log_1.default.error("AbstractStudentView::pushPage(..) - ERROR: " + err.message);
        });
    }
    render() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.prepareData();
            this.renderGrades();
            this.renderRepositories();
        });
    }
    getStudent() {
        return this.person;
    }
    fetchData(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.remote + endpoint;
            const response = yield fetch(url, this.getOptions());
            if (response.status === 200) {
                Log_1.default.trace("AbstractStudentView::fetchData( " + endpoint + " ) - 200 received");
                const json = yield response.json();
                Log_1.default.trace("AbstractStudentView::fetchData( " + endpoint + " ) - payload: " + JSON.stringify(json));
                if (typeof json.success !== "undefined") {
                    Log_1.default.trace("AbstractStudentView::fetchData( " + endpoint + " ) - success: " + json.success);
                    return json.success;
                }
                else {
                    Log_1.default.trace("AbstractStudentView::fetchData( " + endpoint + " ) - ERROR: " + json.failure.message);
                    throw new Error(json.failure.message);
                }
            }
            else {
                Log_1.default.trace("AbstractStudentView::fetchData( " + endpoint + " ) - teams !200 received");
            }
            return null;
        });
    }
    getOptions() {
        return {
            headers: ViewAs_1.ViewAs.addHeader({
                "Content-Type": "application/json",
                user: localStorage.user,
                token: localStorage.token,
                org: localStorage.org,
            }),
        };
    }
    prepareData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.grades = [];
            this.person = null;
            try {
                this.person = (yield this.fetchData("/portal/person"));
            }
            catch (err) {
                Log_1.default.error("AbstractStudentView::prepareData() - fetching person; ERROR: " + err.message);
                UI_1.UI.showError(err.message);
                this.person = null;
            }
            try {
                this.grades = (yield this.fetchData("/portal/grades"));
                if (this.grades === null) {
                    this.grades = [];
                }
            }
            catch (err) {
                Log_1.default.error("AbstractStudentView::prepareData() - fetching person; ERROR: " + err.message);
                UI_1.UI.showError(err.message);
                this.grades = [];
            }
            try {
                this.repos = (yield this.fetchData("/portal/repos"));
                if (this.repos === null) {
                    this.repos = [];
                }
            }
            catch (err) {
                Log_1.default.error("AbstractStudentView::prepareData() - fetching repos; ERROR: " + err.message);
                UI_1.UI.showError(err.message);
                this.repos = [];
            }
            return;
        });
    }
    renderGrades() {
        var _a;
        Log_1.default.trace("AbstractStudentView::renderGrades() - start");
        if (document.getElementById("studentGradeTable") === null) {
            Log_1.default.error("AbstractStudentView::renderGrades() - element is missing; grades not rendered.");
            return;
        }
        if (this.grades === null || this.grades.length < 1) {
            const el = document.getElementById("studentGradeTable");
            el.innerHTML = "No released grades.";
        }
        else {
            const headers = [
                {
                    id: "id",
                    text: "Deliv Id",
                    sortable: true,
                    defaultSort: true,
                    sortDown: false,
                    style: "padding-left: 1em; padding-right: 1em; text-align: center;",
                },
                {
                    id: "grade",
                    text: "Grade",
                    sortable: true,
                    defaultSort: false,
                    sortDown: true,
                    style: "padding-left: 1em; padding-right: 1em; text-align: center;",
                },
                {
                    id: "comment",
                    text: "Comment",
                    sortable: false,
                    defaultSort: false,
                    sortDown: true,
                    style: "padding-left: 1em; padding-right: 1em; text-align: left;",
                },
            ];
            const st = new SortableTable_1.SortableTable(headers, "#studentGradeTable");
            for (const grade of this.grades) {
                let scoreToDisplay = grade.score;
                if ((_a = grade === null || grade === void 0 ? void 0 : grade.custom) === null || _a === void 0 ? void 0 : _a.displayScore) {
                    Log_1.default.info("AbstractStudentView::renderGrades() - using custom display score: " + grade.custom.displayScore);
                    scoreToDisplay = grade.custom.displayScore;
                }
                let scoreHTML = "";
                if (scoreToDisplay === null) {
                    scoreToDisplay = "Not Set";
                    scoreHTML = scoreToDisplay;
                }
                else if (grade.URL === null) {
                    scoreHTML = String(scoreToDisplay);
                }
                else {
                    scoreHTML = "<a href='" + grade.URL + "'>" + scoreToDisplay + "</a>";
                }
                let comment = grade.comment;
                if (comment === null) {
                    comment = "";
                }
                let commentDisplay = "";
                let commentHTML = "";
                if (comment !== "") {
                    commentDisplay = "View Comment";
                    commentHTML = '<a href="#" class="studentFeedbackLink" data-grade-index="' + this.grades.indexOf(grade) + '">View Feedback</a>';
                }
                else {
                    commentDisplay = "No Comment";
                    commentHTML = "";
                }
                const row = [
                    { value: grade.delivId, html: grade.delivId },
                    { value: scoreToDisplay, html: scoreHTML },
                    { value: commentDisplay, html: commentHTML },
                ];
                st.addRow(row);
            }
            st.generate();
            this.wireFeedbackLinks(document.getElementById("studentGradeTable"));
        }
    }
    wireFeedbackLinks(container) {
        if (container.dataset.feedbackWired === "true") {
            return;
        }
        container.dataset.feedbackWired = "true";
        const that = this;
        container.addEventListener("click", function (evt) {
            const link = evt.target.closest("a.studentFeedbackLink");
            if (link === null) {
                return;
            }
            evt.preventDefault();
            const grade = that.grades[Number(link.dataset.gradeIndex)];
            if (typeof grade === "undefined") {
                Log_1.default.warn("AbstractStudentView::wireFeedbackLinks(..) - no grade for index: " + link.dataset.gradeIndex);
                return;
            }
            that.showFeedback(grade);
        });
    }
    showFeedback(grade) {
        var _a;
        Log_1.default.info("AbstractStudentView::showFeedback( " + grade.delivId + " ) - start");
        UI_1.UI.showHtmlDialog("Feedback: " + grade.delivId, Markdown_1.Markdown.render((_a = grade.comment) !== null && _a !== void 0 ? _a : ""));
    }
    renderRepositories() {
        Log_1.default.trace("AbstractStudentView::renderRepositories() - start");
        if (this.repos === null || this.repos.length < 1) {
            const el = document.getElementById("studentRepoTable");
            el.innerHTML = "Repositories not yet provisioned.";
        }
        else {
            const headers = [
                {
                    id: "id",
                    text: "Repository",
                    sortable: true,
                    defaultSort: false,
                    sortDown: true,
                    style: "padding-left: 1em; padding-right: 1em; text-align: center;",
                },
                {
                    id: "delivId",
                    text: "Deliverable",
                    sortable: true,
                    defaultSort: true,
                    sortDown: false,
                    style: "padding-left: 1em; padding-right: 1em; text-align: center;",
                },
            ];
            const st = new SortableTable_1.SortableTable(headers, "#studentRepoTable");
            for (const repo of this.repos) {
                const row = [
                    { value: repo.id, html: "<a href='" + repo.URL + "'>" + repo.id + "</a>" },
                    { value: repo.delivId, html: repo.delivId },
                ];
                st.addRow(row);
            }
            st.generate();
        }
    }
}
exports.AbstractStudentView = AbstractStudentView;
